import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Plus, Mail, Phone, Search } from "lucide-react";
import { toast } from "sonner";

export default function Contacts() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name:"", title:"", email:"", phone:"", role:"", notes:"" });

  const load = async () => setItems((await api.get("/contacts")).data);
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!form.name.trim()) return toast.error("Name required");
    await api.post("/contacts", form);
    toast.success("Contact added"); setOpen(false); load();
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-end">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Directory</div>
          <h1 className="text-3xl font-bold">Contacts</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-slate-900 hover:bg-slate-800" data-testid="add-contact-btn"><Plus className="w-4 h-4 mr-1"/>Add Contact</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>New Contact</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Name</Label><Input value={form.name} onChange={e=>setForm({...form, name:e.target.value})} data-testid="ct-name"/></div>
              <div><Label>Title</Label><Input value={form.title} onChange={e=>setForm({...form, title:e.target.value})}/></div>
              <div><Label>Role</Label><Input value={form.role} onChange={e=>setForm({...form, role:e.target.value})}/></div>
              <div><Label>Email</Label><Input value={form.email} onChange={e=>setForm({...form, email:e.target.value})}/></div>
              <div><Label>Phone</Label><Input value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})}/></div>
              <div><Label>Notes</Label><Textarea value={form.notes} onChange={e=>setForm({...form, notes:e.target.value})}/></div>
              <Button onClick={submit} className="bg-slate-900 hover:bg-slate-800" data-testid="ct-submit">Save</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="p-4 border-slate-200 flex gap-3 items-center">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input placeholder="Search contacts by name, title, role, agency..." className="pl-9" value={q} onChange={e=>setQ(e.target.value)} data-testid="ct-search"/>
        </div>
        <div className="text-xs text-slate-500 font-mono">
          {items.filter(c => q==="" || `${c.name} ${c.title||""} ${c.role||""} ${c.email||""} ${c.notes||""}`.toLowerCase().includes(q.toLowerCase())).length} shown
        </div>
      </Card>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.filter(c => q==="" || `${c.name} ${c.title||""} ${c.role||""} ${c.email||""} ${c.notes||""}`.toLowerCase().includes(q.toLowerCase())).map(c => (
          <Card key={c.id} className="p-5 border-slate-200">
            <h3 className="font-semibold text-slate-900">{c.name}</h3>
            <div className="text-xs text-slate-500">{c.title}</div>
            {c.role && <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold mt-2">{c.role}</div>}
            <div className="text-xs text-slate-600 mt-2 space-y-1">
              {c.email && <div className="flex items-center gap-1"><Mail className="w-3 h-3" /> {c.email}</div>}
              {c.phone && <div className="flex items-center gap-1"><Phone className="w-3 h-3" /> {c.phone}</div>}
            </div>
            {c.notes && <p className="text-xs text-slate-500 mt-2">{c.notes}</p>}
          </Card>
        ))}
      </div>
    </div>
  );
}
